export default __webpack_public_path__ + "static/media/qr-img.ef8e0823.PNG";